import { render, staticRenderFns } from "./pogs-form__item--pregnancy.vue?vue&type=template&id=64ad9e84&scoped=true&"
import script from "./pogs-form__item--pregnancy.vue?vue&type=script&lang=js&"
export * from "./pogs-form__item--pregnancy.vue?vue&type=script&lang=js&"
import style0 from "./pogs-form__item--pregnancy.vue?vue&type=style&index=0&id=64ad9e84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad9e84",
  null
  
)

export default component.exports